<!--  -->
<template>
  <div>
    <el-form ref="ruleForm" :model="ruleForm" status-icon label-width="60px" class="demo-ruleForm">
      <el-form-item label="群名称">
        <el-input v-model="ruleForm.group_chat_name" />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="submitForm">提交</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { editCrowdname } from '@/api/officialaccount.js'
export default {
  components: {},
  data() {
    return {
      ruleForm: {
        group_chat_name: ''
      },
      up_chatroom_id: null,
      group_chat_owner: null
    }
  },
  created() {

  },
  mounted() {

  },
  methods: {
    async submitForm() {
      if (this.ruleForm.group_chat_name === '') {
        this.$message.error('请输入群名称')
        return
      }
      const data = await editCrowdname({
        up_chatroom_id: this.up_chatroom_id,
        name: this.ruleForm.group_chat_name,
        group_chat_owner: this.group_chat_owner
      })
      console.log('data', data)
      this.$emit('updata')
    },
    send(item) {
      this.ruleForm.group_chat_name = item.group_chat_name
      this.up_chatroom_id = item.up_chatroom_id
      this.group_chat_owner = item.group_chat_owner
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */

</style>
